import React from 'react';
import {SECURITY_COLOR} from "../GameStyleUI";
import GameWindowHeader from "../GameWindowHeader";
import GameWindowBg from "../GameWindowBg";
import security_header_icon from "../../../images/gameplay_ui/icons/security_header_icon.svg";
import star_empty from "../../../images/gameplay_ui/icons/star_empty.svg";
import star_full from "../../../images/gameplay_ui/icons/star_full.svg";
import minus from "../../../images/gameplay_ui/icons/minus.svg"
import add from "../../../images/gameplay_ui/icons/plus.svg"
import CardWithCost from "../GeneralCards/CardWithCost";
import {GetSecurityLevelCost, MaxSecurityLevel} from "../../../gameplay/model/Balance";
import GameButtonWithIcon from "../GameButtonWithIcon";
import GameData from "../../../gameplay/model/GameData";
import UtilsFunctions from "../../../utils/UtilsFunctions";

export default class InvestSecurityCard extends React.Component {
    constructor() {
        super();

        this.addedTimes = 0;
        let securityIndex = UtilsFunctions.getRoleNameIndex("Зам. по инфраструктуре и ремонту");
        this.isSecurityDirector = UtilsFunctions.playerHasRole(securityIndex);

        if (!this.isSecurityDirector) {
            alert("Инвестициями по безопасности может заниматься только Зам. по инфраструктуре и ремонту");
        }
    }

    minus() {
        this.addedTimes--;
        let state = this.props.parent.state;
        state.runtimeData.securityLevel -= 1;

        this.props.parent.setState(state);
    }

    add() {
        if (this.addedTimes < 2) {
            this.addedTimes++;
            let state = this.props.parent.state;
            state.runtimeData.securityLevel += 1;

            this.props.parent.setState(state);
        }
    }

    initSecurityLevelCard(securityLevel) {
        let currentLevel = GameData.CurrentGame.securityLevel;
        let styleContainer = {
            padding: "4px",
            paddingBottom: "0px",
            display: "flex",
            justifyContent: "space-between"
        }
        let buttonsStyle = {
            display: "flex",
            paddingLeft: "5px",
            paddingRight: "5px",
            justifyContent: "space-between"
        }
        let value = [];
        for (let i = 0; i < MaxSecurityLevel; i++) {
            value.push(<img key={'star-'+i} alt={"icon"} src={securityLevel > i ? star_full : star_empty}/>)
        }
        let cost = GetSecurityLevelCost();
        let colors = SECURITY_COLOR;
        let isCanBuy = this.props.parent.getAvailableCash() >= cost;

        let card = <div>
            <div style={styleContainer}>
                <CardWithCost cost={cost}
                              colors={colors}
                              icon={security_header_icon}
                              iconSize={16}
                              title={"уровень"}
                              width={130}
                              posL={0}
                              headerHeight={36} height={40}/>
            </div>
            <div style={buttonsStyle}>
                <GameButtonWithIcon
                    colorStart={colors[0]}
                    colorEnd={colors[1]}
                    icon={minus}
                    onClick={this.minus.bind(this)}
                    disabled={!this.isSecurityDirector || currentLevel === securityLevel}/>
                {value}
                <GameButtonWithIcon
                    colorStart={colors[0]}
                    colorEnd={colors[1]}
                    icon={add}
                    onClick={this.add.bind(this)}
                    disabled={!this.isSecurityDirector || (securityLevel - currentLevel === 2 || !isCanBuy)}
                />
            </div>
        </div>
        return card;
    }

    render() {
        let securityLevel = this.props.securityLevel;
        let colors = SECURITY_COLOR;
        return <div>
            <GameWindowHeader
                width={140}
                height={30}

                title={"Безопасность"}
                colorStart={colors[0]}
                colorEnd={colors[1]}
                fontSize={12}
                lineHeight={10}
                positionTop={10}
                positionLeft={5}
            />
            <GameWindowBg width={140} height={105} color={"#F2F2F2"} value={this.initSecurityLevelCard(securityLevel)}/>
        </div>
    }
}
